/* eslint-disable max-classes-per-file */
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';

export class LoadUserChemicalExposureLog {
  static readonly type = '[Chemical Exposure] Load User Chemical Exposure Log';
  constructor(
    public userId: string,
    public filter?: MainTableFilterModel
  ) {}
}

export class LoadMyUserChemicalExposureLog {
  static readonly type = '[Chemical Exposure] Load My Chemical Exposure Log';
  constructor(
    public userId: string,
    public filter?: MainTableFilterModel
  ) {}
}

export class ClearUserChemicalExposureLog {
  static readonly type = '[Chemical Exposure] Clear User Chemical Exposure Log';
}

export class PrintUserChemicalExposureLogPdf {
  static readonly type = '[Chemical Exposure] Print User Chemical Exposure Log Pdf';
  constructor(
    public userId: string,
    public filter?: MainTableFilterModel
  ) {}
}

export class PrintMyUserChemicalExposureLogPdf {
  static readonly type = '[Chemical Exposure] Print My Chemical Exposure Log Pdf';
  constructor(
    public userId: string,
    public filter?: MainTableFilterModel
  ) {}
}
